import { Component, Input, Output, EventEmitter } from '@angular/core';

import { SelectorOption } from './generic-selector.component';

export type EnergySourceType = 'power' | 'energy';

const ENERGY_SOURCE_OPTIONS: Record<EnergySourceType, SelectorOption> = {
  power: {
    id: 'power',
    iconActive: 'cmp-assets/power.svg',
    iconInactive: 'cmp-assets/power-off.svg',
    activeClass: 'bg-accent-100',
  },
  energy: {
    id: 'energy',
    iconActive: 'cmp-assets/energy.svg',
    iconInactive: 'cmp-assets/energy-off.svg',
    activeClass: 'bg-green-100',
  },
};

@Component({
  selector: 'app-energy-source-selector',
  templateUrl: './energy-source-selector.component.html',
  styleUrls: ['./custom-source-selector.component.scss'],
})
export class EnergySourceSelectorComponent {
  @Input() source: EnergySourceType[] = ['power'];
  @Input() options: EnergySourceType[] = ['power', 'energy'];
  @Input() mode: 'single' | 'multiple' = 'multiple';
  @Output() selection = new EventEmitter<EnergySourceType[]>();

  get selectorOptions(): SelectorOption[] {
    return this.options.map((opt) => ENERGY_SOURCE_OPTIONS[opt]);
  }

  onSelection(selected: string[]) {
    this.selection.emit(selected as EnergySourceType[]);
  }
}
